export default "__VITE_ASSET__475a8276__$_?react__"